import React, {
  PropsWithChildren,
  useCallback,
  useEffect,
  useState
} from 'react';
import { Auth } from '@aws-amplify/auth';
import { CognitoIdToken, CognitoUserSession } from 'amazon-cognito-identity-js';

import { GenericObject } from '../../utils/GenericObject';
import { AuthContext } from './AuthContext';
import { appConfig } from '../../config/appConfig';

export const InContainerAuthProvider = ({
  children
}: PropsWithChildren<{}>) => {
  const [userTokenData, setUserTokenData] = useState<GenericObject | undefined>(
    undefined
  );
  const [triedToFetchTheUser, setTriedToFetchTheUser] = useState<boolean>(
    false
  );
  const [error, setError] = useState<string | undefined>(undefined);

  const getUserData = useCallback(async (): Promise<
    GenericObject | undefined
  > => {
    try {
      const currentSession: CognitoUserSession = await Auth.currentSession();
      const userData: CognitoIdToken = currentSession.getIdToken();

      return userData.payload;
    } catch {
      return undefined;
    } finally {
      setTriedToFetchTheUser(true);
    }
  }, []);

  const onLoad = useCallback(async () => {
    try {
      Auth.configure(appConfig.auth);

      setUserTokenData(await getUserData());
    } catch (error) {
      setError(error);
    }
  }, [getUserData]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <AuthContext.Provider value={{ userTokenData, triedToFetchTheUser, error }}>
      {children}
    </AuthContext.Provider>
  );
};
